import React, {useState, useEffect} from "react";
import useAxios from "../../utils/useAxios";
import {useTranslation} from "react-i18next";
import FeatherIcon from "feather-icons-react";
import {toast} from "react-toastify";

const PlayerMergeForm = ({badPlayer, baseId, onSuccess, onClose}) => {
    const {t} = useTranslation();
    const api = useAxios();

    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);
    const [selectedGoodPlayer, setSelectedGoodPlayer] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (query.length >= 2) {
            setLoading(true);
            const timeoutId = setTimeout(() => {
                api.get(`/api/v1.0/players/?base=${baseId}&q=${query}`)
                    .then(res => {
                        // Исключаем самого себя из поиска
                        setResults((res.data.results || []).filter(p => p.id !== badPlayer.id));
                    })
                    .finally(() => setLoading(false));
            }, 400);
            return () => clearTimeout(timeoutId);
        } else {
            setResults([]);
        }
    }, [query, baseId, badPlayer.id]);

    const handleSubmit = async e => {
        e.preventDefault();
        if (!selectedGoodPlayer) {
            toast.error(t("Please select the target player"));
            return;
        }

        const confirmed = window.confirm(t("Are you sure? This will replace all statistics and DELETE the current duplicate."));
        if (!confirmed) return;

        try {
            await api.post(`/api/v1.0/players/${badPlayer.id}/merge/`, {
                target_player_id: selectedGoodPlayer.id
            });
            toast.success(t("Players successfully merged!"));
            onSuccess?.(badPlayer.id);
            onClose?.();
        } catch (error) {
            const backendError = error.response?.data?.error;
            toast.error(backendError || t("Error merging players"));
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <h2>
                <FeatherIcon icon="git-merge"/> {t("Union players")}
            </h2>
            <p>
                {t("You are going to replace player")} <b>{badPlayer?.last_name} {badPlayer?.first_name}</b> {t("with another player. All statistics will be transferred.")}
            </p>

            <div className="form-group">
                <label>{t("Search main player (to keep)")}</label>
                <input
                    type="text"
                    value={query}
                    onChange={e => {
                        setQuery(e.target.value);
                        setSelectedGoodPlayer(null);
                    }}
                    className="form-control"
                    placeholder={t("Type name...")}
                />

                {loading && <small>{t("Searching...")}</small>}

                {results.length > 0 && !selectedGoodPlayer && (
                    <ul style={{ border: '1px solid #ccc', borderRadius: '4px', maxHeight: '180px', overflowY: 'auto', padding: 0, listStyle: 'none', marginTop: '5px' }}>
                        {results.map(p => (
                            <li
                                key={p.id}
                                style={{ padding: '10px', cursor: 'pointer', borderBottom: '1px solid #eee' }}
                                onClick={() => setSelectedGoodPlayer(p)}
                            >
                                <b>{p.last_name} {p.first_name}</b> {p.city ? `(${p.city})` : ''} {p.phone || ''}
                            </li>
                        ))}
                    </ul>
                )}
            </div>

            {selectedGoodPlayer && (
                <div className="form-group">
                    <label>{t("Selected target player")}</label>
                    <div style={{ padding: '12px', background: '#e8f5e9', border: '1px solid #c8e6c9', borderRadius: '4px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span><b>{selectedGoodPlayer.last_name} {selectedGoodPlayer.first_name}</b> {selectedGoodPlayer.city}</span>
                        <FeatherIcon icon="x" style={{cursor: 'pointer'}} onClick={() => setSelectedGoodPlayer(null)} />
                    </div>
                </div>
            )}

            <br/>
            <ul className="tabs">
                <li>
                    <a href="#" className="action-button btn-green" onClick={(e) => {
                        e.preventDefault();
                        e.currentTarget.closest('form').requestSubmit();
                    }}>
                        <FeatherIcon icon="check"/> {t("Merge & Delete")}
                    </a>
                </li>
            </ul>
        </form>
    );
};

export default PlayerMergeForm;